<div class="dialog">
  <div class="dialog-header">
    <div class="user-avatar">
      <div class="inner"
           [ngStyle]="{backgroundImage: 'url(' +  ( user?.photo | apiasset | defaultAsset:'DEFAULT_AVATAR' ) +  ')'}"></div>
      <div class="badge" [ngClass]="{'badge-success': successDialog }">
        <img [src]="successDialog ? './assets/img/check-circle-white.svg' : './assets/img/times-circle-white.svg'"
             width="24" height="24">
      </div>
    </div>
  </div>
  <div class="dialog-body">
    <div class="user-name">
      <span *ngIf="isMorning; else good_night">
        {{'GOOD_MORNING' | translate }}
      </span>
      <ng-template #good_night>{{'GOOD_EVENING' | translate }} </ng-template>
      <span class="user-name--txt">{{user?.firstName}} {{user?.lastName}},</span>
    </div>

    <div *ngIf="!successDialog; else success_dialog">
      <div *ngIf="errorCode === 'unauthorized'">
        <div class="pass-refused">{{ 'PASSAGE_REFUSED' | translate }}. {{'7281' | translate}} <!--Please contact the reception--></div>
      </div>
      <div *ngIf="errorCode === 'timeout'">
        <div
          class="pass-refused">{{ 'THE_VALIDATION_PROCESS_HAS_FAILED' | translate }} {{ 'TRY_AGAIN_OR_CONTACT_RECEPTION_IF_PROBLEM_PERSISTS' | translate }}</div>
      </div>
      <div *ngIf="errorCode === 'unexpected'">
        <div
          class="pass-refused">{{ 'GENERIC_ERROR_MSG' | translate }} {{ 'TRY_AGAIN_OR_CONTACT_RECEPTION_IF_PROBLEM_PERSISTS' | translate }}</div>
      </div>
      <div class="text-center" style="margin-top: 60px;">
        <button class="dialog-btn dialog-btn-color--danger" (click)="quit()">{{'QUIT' | translate}}</button>
      </div>
    </div>
    <ng-template #success_dialog>
      <div *ngIf="!quizSaved; else quiz_saved">
        <div class="welcome-message">
          {{'WHAT_DO_YOU_WANT_TO_DO_TODAY' | translate }}
        </div>
        <div class="qst-wrapper">
          <div class="qst-opt" (click)="checkItem(1)" [ngClass]="{active: selected === 1}">
            <div class="title">{{ 'BODYBUILDING_SESSION' | translate }}</div>
          </div>
          <div class="qst-opt" (click)="checkItem(2)" [ngClass]="{active: selected === 2}">
            <div class="title">{{'GROUP_CLASS' | translate}}</div>
          </div>
          <div class="qst-opt" (click)="checkItem(3)" [ngClass]="{active: selected === 3}">
            <div class="title">{{'OTHER' | translate}}</div>
          </div>
        </div>
        <div style="text-align: center;">
          <button class="dialog-btn" (click)="save()" [disabled]="selected === null">{{'SEND' | translate}}</button>
        </div>
      </div>
      <ng-template #quiz_saved>
        <div class="qst-success">
          <div class="greetings-row ">
            {{'YOUR_ANSWER_HAS_BEEN_SAVED' | translate}}. {{'THANK_YOU' | translate}}.
          </div>
          <div class="btn-row">
            <button class="dialog-btn dialog-btn-color--primary"
                    (click)="goToScheduler()">
              {{'BROWSE_THE_PLANNING' | translate}}
              <!--Browse the planning-->
            </button>
            <button class="dialog-btn dialog-btn-color--danger cancel-btn"
                    (click)="quit()">
              {{'QUIT'| translate}}
            </button>
          </div>
        </div>
      </ng-template>
    </ng-template>
  </div>
</div>
